import React from 'react';
import { StyledLogo } from './styles';
import Logo3 from '../../assets/logo/logo 3.svg';

const Logo = () => {
  return <StyledLogo src={Logo3} alt='logo asados del valle'/>;
};

export default Logo;
